import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm, Controller } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useStateContext } from '../context/StateContext'
import { HEIGHT_FORMAT } from '../utils/constants'
import CTA from '../../../common/CTAButton/CTAButton'
import { componentEvent } from '../../../utils/tracking'
import arrowLeft from '../assets/svgs/arrow-left.svg'
import boy from '../assets/svgs/boy.svg'
import girl from '../assets/svgs/girl.svg'

export default function Child() {
  const [state, setState] = useStateContext()
  const { t } = useTranslation()
  const schema = yup
    .object({
      height: yup
        .string()
        .required(t('height-error'))
        .test('validHeight', t('height-error-range'), (value) => {
          const feetSplit = value.split('')
          const feet = feetSplit[0]
          const inchSplit = value.split(/[^0-9]/)
          const inches = inchSplit[2]
          const heightInInches = +feet * 12 + +inches

          if (heightInInches <= 83) {
            return true
          }

          return false
        }),
      weight: yup
        .string()
        .required(t('weight-error'))
        .test('validWeight', t('weight-error-range'), (value) => {
          const weightSplit = value.split('lbs')
          const weight = parseInt(weightSplit[0], 10)

          if (weight >= 60 && weight <= 800) {
            return true
          }

          return false
        }),
    })
    .required()
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) })

  const calculateBmi = (data) => {
    const feetSplit = data.height.split('')
    const feet = feetSplit[0]
    const inchSplit = data.height.split(/[^0-9]/)
    const inches = inchSplit[2]
    const weightSplit = data.weight.split('lbs')
    const weight = parseInt(weightSplit[0], 10)
    const heightInInches = +feet * 12 + +inches
    const bmi = parseFloat((weight / heightInInches ** 2) * 703)

    componentEvent('bmi-calculator', 'content', 'click', 'Submit')

    setState(() => ({
      ...state,
      step: 'results',
      bmi,
      height: heightInInches,
      weight,
      child: true,
    }))
  }

  function handleBack() {
    componentEvent('bmi-calculator', 'content', 'click', 'Back')
    setState(() => ({
      ...state,
      step: 'child-gender',
      gender: null,
    }))
  }

  return (
    <div className="layout child">
      <div className="layout__left">
        <div className="container">
          <form onSubmit={handleSubmit(calculateBmi)}>
            <fieldset>
              <label htmlFor="height">{t('height')}</label>
              <Controller
                control={control}
                name="height"
                render={({ field: { onChange, name, value } }) => (
                  <NumberFormat
                    className={`input ${errors.height ? 'error' : ''}`}
                    displayType="input"
                    format={HEIGHT_FORMAT}
                    placeholder={`i.e. 5' 2"`}
                    suffix="Feet/Inches"
                    name={name}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.height && (
                <div className="error-message">
                  <p>{errors.height.message}</p>
                </div>
              )}
            </fieldset>
            <fieldset>
              <label htmlFor="weight">{t('weight')}</label>
              <Controller
                control={control}
                name="weight"
                render={({ field: { onChange, name, value } }) => (
                  <NumberFormat
                    className={`input ${errors.weight ? 'error' : ''}`}
                    displayType="input"
                    placeholder="i.e. 90 lbs"
                    suffix="lbs"
                    name={name}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
              {errors.weight && (
                <div className="error-message">
                  <p>{errors.weight.message}</p>
                </div>
              )}
            </fieldset>
            <fieldset>
              <CTA className="cta" type="submit">
                {t('submit')}
              </CTA>
            </fieldset>
          </form>
        </div>
      </div>
      <div className="layout__right">
        <div className="container">
          <img
            className="figure"
            src={state.gender === 'm' ? boy : girl}
            alt=""
          />
          <div className="action">
            <h3>
              {t('calculate-a')}
              <span>{t('child')}</span>
            </h3>
            <CTA className="cta cta__arrow" onClick={() => handleBack()}>
              <img src={arrowLeft} alt="" />
            </CTA>
          </div>
        </div>
      </div>
    </div>
  )
}
